import styled from 'styled-components';
import { StockModelCardCaptionStyled } from '../StockModelCardCaptionStyled';
import { rem } from 'polished';

export const StockModelCardCaptionStyledDS = styled(StockModelCardCaptionStyled)`
    .stockModelCard-imageContainer--info__list {
        dt,
        dd {
            font-size: ${rem('14px')};
        }
    }

    .highlighted-text {
        font-size: ${rem('16px')};
    }
`;
